import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import Select, { SelectOption } from '@rio-cloud/rio-uikit/Select';
import SimpleDialog from '@rio-cloud/rio-uikit/SimpleDialog';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { config } from '../../../../config';
import { getLocale } from '../../../../configuration';
import { changeLocale } from '../../../../configuration/lang/actions';
import { getUserProfile } from '../../../../configuration/login/selectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { VolkswagenAccountMenuProps } from './types';

export const VOLKSWAGEN_ACTION_BAR_ITEM_TEST_ID = 'VOLKSWAGEN_ACTIONBAR_ITEM_TEST_ID';

export const VolkswagenAccountMenu = (overrides: Partial<VolkswagenAccountMenuProps> = {}) => {
    const idToken = useAppSelector((state) => getUserProfile(state as any)) as any;
    const preferredUsername = overrides.preferredUsername ?? idToken?.preferredUsername;
    const formattedPreferredUserName = preferredUsername ? ` (${preferredUsername.toUpperCase()})` : '';

    const [isShown, setShow] = useState(false);

    return (
        <ActionBarItem id={'accountMenu'}>
            <SimpleDialog
                title={<FormattedMessage id={'otc.vwusermenu.LanguageSelectionDialog'} />}
                content={<LanguageSelectionComponent />}
                show={isShown}
                onClose={() => setShow(false)}
            />
            <ActionBarItem.Icon>
                <span className={'icon rioglyph rioglyph-user'} data-testid={VOLKSWAGEN_ACTION_BAR_ITEM_TEST_ID} />
            </ActionBarItem.Icon>
            <ActionBarItem.Popover>
                <div className={'popover-content margin-0 padding-0'}>
                    <div data-cy={'user-details'} className={'padding-bottom-10 text-color-dark'}>
                        <div>
                            <b>{`${overrides.firstName ?? idToken?.givenName} ${overrides.lastName ?? idToken?.familyName}${formattedPreferredUserName}`}</b>
                        </div>
                        <div>{overrides.email ?? idToken?.email}</div>
                    </div>
                    <hr className={'margin-top-5 margin-bottom-5'} />
                    <button
                        type='button'
                        className={'btn btn-info btn-link btn-link-inline'}
                        onClick={() => setShow(true)}
                    >
                        <span className={'rioglyph rioglyph-cog'} />
                        <FormattedMessage id={'otc.vwusermenu.button.languageSelection'} />
                    </button>
                    <hr className={'margin-top-5 margin-bottom-5'} />
                    <ul className={'list-unstyled'}>
                        <li>
                            <button
                                className={'btn btn-link btn-s padding-0 text-color-dark'}
                                tabIndex={1}
                                data-cy={'logout-btn'}
                                onClick={() => {
                                    if (overrides.logout) {
                                        overrides.logout();
                                        return;
                                    }
                                    if (config.logoutUri) {
                                        window.location.href = config.logoutUri;
                                    }
                                }}
                            >
                                <span className={'rioglyph rioglyph-off margin-right-5 text-size-16 text-color-dark'} />
                                <FormattedMessage id={'otc.button.logout'} />
                            </button>
                        </li>
                    </ul>
                </div>
            </ActionBarItem.Popover>
        </ActionBarItem>
    );
};

const LanguageSelectionComponent = () => {
    const dispatch = useAppDispatch();
    const currentLocale = useAppSelector(getLocale);
    const options: SelectOption[] = [
        { id: 'de-DE', label: 'Deutsch' },
        { id: 'en-GB', label: 'English' },
    ];
    return (
        <div>
            <Select
                options={options}
                onChange={(option) => option && dispatch(changeLocale(option.id))}
                value={[currentLocale]}
            />
        </div>
    );
};
